import { Classes } from '@blueprintjs/core';
import {
  Cell,
  Column,
  ColumnHeaderCell2,
  EditableName,
  Table2,
} from '@blueprintjs/table';
import classNames from 'classnames';
import * as React from 'react';
import { Text } from 'vet-bones/components';

import {
  TEST_IDS,
  getProjectFileUploadPanelColumnLabelTestId,
} from 'src/constants/testIds';
import { ProjectFileUploadField } from 'src/store/state/projects';
import * as copy from 'src/templates/copy';

type ProjectFileUploadTableProps = {
  disableEditing?: boolean;
  fields: ProjectFileUploadField[];
  rows: string[][];
  onFieldLabelChange: (value: string, label: string) => void;
};

export const ProjectFileUploadTable: React.VFC<ProjectFileUploadTableProps> = ({
  disableEditing,
  fields,
  rows,
  onFieldLabelChange,
}) => (
  <div
    className="sd-project-file-upload-table"
    data-heap-redact-attributes="title"
    data-testid={TEST_IDS.projectFileUploadPanel.table}
  >
    <Table2 enableRowHeader={false} numRows={rows.length}>
      {fields.map((field) => (
        <Column
          key={field.value}
          cellRenderer={(rowIdx, colIdx) => <Cell>{rows[rowIdx][colIdx]}</Cell>}
          columnHeaderCellRenderer={(colIdx) => (
            <ColumnHeaderCell2
              className="sd-project-file-upload-table__header"
              name={fields[colIdx].label}
              nameRenderer={(name) => (
                <div
                  data-testid={getProjectFileUploadPanelColumnLabelTestId(
                    field.value
                  )}
                >
                  {disableEditing ? (
                    <Text className={Classes.TEXT_OVERFLOW_ELLIPSIS}>
                      {name}
                    </Text>
                  ) : (
                    <EditableName
                      name={name}
                      onChange={(label) =>
                        onFieldLabelChange(fields[colIdx].value, label)
                      }
                    />
                  )}
                </div>
              )}
            >
              <div
                className={classNames(
                  'sd-project-file-upload-table__statistics',
                  Classes.TEXT_SMALL,
                  Classes.TEXT_DISABLED
                )}
              >
                {copy.components.projectResourceDialog.projectFileUploadPanel.statistics.distinct(
                  field.statistics.distinct
                )}
                <br />
                {copy.components.projectResourceDialog.projectFileUploadPanel.statistics.records(
                  field.statistics.records
                )}
              </div>
            </ColumnHeaderCell2>
          )}
          name={field.label}
        />
      ))}
    </Table2>
  </div>
);
